import "./Contact.css";
import Button from "../../components/Button/Button";

function Contact() {
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const formData = new FormData(e.currentTarget);

    const data = {
      fullName: formData.get("fullName"),
      email: formData.get("email"),
      phone: formData.get("phone"),
      homeCountry: formData.get("homeCountry"),
      travelMonth: formData.get("travelMonth"),
      travelers: formData.get("travelers"),
      interests: formData.getAll("interests"),
      message: formData.get("message"),
    };

    const response = await fetch("/send-mail.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });

    if (response.ok) {
      alert("Message sent successfully!");
      e.currentTarget.reset();
    } else {
      alert("Failed to send message");
    }
  };

  return (
    <>
      {/* Intro Section */}
      <section className="contact-section">
        <div className="contact-info">
          <p>ALL ABOUT YOU</p>
          <h2>
            Share your dreams we'll weave them into an unforgettable Bhutanese
            journey.
          </h2>
        </div>
      </section>

      {/* Form Section */}
      <section className="form-section">
        <form className="contact-form" onSubmit={handleSubmit}>
          <h3>CONTACT DETAILS</h3>

          <div className="form-row">
            <div className="form-group">
              <label>Full name*</label>
              <input type="text" name="fullName" required />
            </div>

            <div className="form-group">
              <label>Email*</label>
              <input type="email" name="email" required />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Phone</label>
              <input type="tel" name="phone" />
            </div>

            <div className="form-group">
              <label>Home country*</label>
              <select name="homeCountry" required>
                <option value="">Select</option>
                <option value="bhutan">Bhutan</option>
                <option value="india">India</option>
                <option value="usa">United States</option>
                <option value="uk">United Kingdom</option>
                <option value="australia">Australia</option>
                <option value="other">Other</option>
              </select>
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Preferred travel month*</label>
              <input type="month" name="travelMonth" required />
            </div>

            <div className="form-group">
              <label>Number of travelers*</label>
              <input type="number" name="travelers" min="1" required />
            </div>
          </div>

          <div className="form-group full-width">
            <label>Interests</label>
            <div className="checkbox-group">
              <label>
                <input type="checkbox" name="interests" value="culture" />
                Culture & Heritage
              </label>
              <label>
                <input type="checkbox" name="interests" value="nature" />
                Nature & Outdoors
              </label>
              <label>
                <input type="checkbox" name="interests" value="wellness" />
                Wellness
              </label>
              <label>
                <input type="checkbox" name="interests" value="festival" />
                Festivals
              </label>
            </div>
          </div>

          <div className="form-group full-width">
            <label>Trip notes</label>
            <textarea name="message" rows={4}></textarea>
          </div>

          <div className="form-group full-width">
            <Button buttonName="Submit" theme="dark" type="submit" />
          </div>
        </form>
      </section>
    </>
  );
}

export default Contact;
